import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import EditorWarningIcon from '@atlaskit/icon/utility/migration/warning--editor-warning';
import { messages } from '@atlaskit/media-ui';
import { R300 } from '@atlaskit/theme/colors';
import { ErrorMessageWrapper, TitleBoxWrapper } from './titleBoxComponents';
export var FailedTitleBox = function FailedTitleBox(_ref) {
  var breakpoint = _ref.breakpoint,
    _ref$customMessage = _ref.customMessage,
    customMessage = _ref$customMessage === void 0 ? messages.failed_to_load : _ref$customMessage;
  return /*#__PURE__*/React.createElement(TitleBoxWrapper, {
    breakpoint: breakpoint
  }, /*#__PURE__*/React.createElement(ErrorMessageWrapper, null, /*#__PURE__*/React.createElement(EditorWarningIcon, {
    label: 'Warning',
    LEGACY_size: 'small',
    LEGACY_margin: "0 ".concat("var(--ds-space-negative-025, -2px)"),
    color: "var(--ds-text-danger, ".concat(R300, ")")
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, customMessage))));
};